import { PropsWithChildren, ReactElement, useState } from "react";
import { className } from "../../../shared/helpers";
import styles from "./Sidebar.module.scss";

interface SidebarProps
{
    header?: ReactElement;
    footer?: ReactElement;
    customClassName?: string;
    collapsible?: boolean;
    close: () => void;
}

const Sidebar = (props: PropsWithChildren<SidebarProps>): ReactElement =>
{
    const [collapsed, setCollapsed] = useState<boolean>(true);

    return (
        <aside
            {...className(
                styles.sidebar,
                props.customClassName, {
                [styles.collapsed]: props.collapsible && collapsed
            })}
        >
            <header className={styles.header}>
                {props.header && (
                    <div className={styles.data}>{props.header}
                    <button className={styles.resetBtn} onClick={props.close}>
                        <i className="material-icons">close</i>
                    </button>
                    </div>
                )}
                <div className={styles.actions}>
                    {props.collapsible && (
                        <button className="icon-btn" onClick={() => setCollapsed(!collapsed)}>
                            <i className="material-icons">{collapsed ? "expand_less" : "expand_more"}</i>
                        </button>
                    )}

                    <button className="icon-btn" onClick={props.close}>
                        <i className="material-icons">close</i>
                    </button>
                </div>
            </header>

            <section {...className(styles.main, "scroll-container")}>
                <div>{props.children}</div>
            </section>

            {props.footer && (
                <footer className={styles.footer}>{props.footer}</footer>
            )}
        </aside>
    );
};

export default Sidebar;
